import React from 'react';
import DataModal from 'src/components/Modal/DataModal';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography';
import { pathOr } from 'ramda';
import { useStyles } from './Login.styles';

interface Props {
    toggleModal: () => void;
    selectMagicLink: boolean;
    control: any;

}
const MagicLinkModal = ({ toggleModal, selectMagicLink, control }: Props) => {
    const classes = useStyles();
    const steps = [
        {
            label: 'A login link has been sent to your verified email address',
            prefix_number: 1,
        },
        {
            label:
                'Use the link provided in the email to access your account without needing a password',
            prefix_number: 2,
        },
    ];
    const activeStep = pathOr(0, ['prefix_number'], steps);

    return (
        <DataModal
            toggleModal={toggleModal}
            showModal={selectMagicLink}
            modalSize={'md'}
            modalTitle={'Great news!'}
            titleStyles={{ marginTop: '30px', fontSize: '24px' }}
            contentStyles={{ margin: '0 auto' }}
            buttonText="OK"
            buttonVariant="contained"
            modalContent={
                <>
                    <Typography
                        fontSize={14}
                        component="p"
                        lineHeight="initial"
                        sx={{ marginBottom: 2 }}
                    >
                        We've sent you an email with secure login link to{' '}
                        <Typography component="span" fontWeight={800}>
                            {pathOr('', ['_formValues', 'email'], control)}
                        </Typography>
                    </Typography>
                    <Typography fontSize={16} py={2} fontWeight={600}>
                        Next steps
                    </Typography>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((step, index) => (
                            <Step
                                key={step.label}
                                classes={{
                                    root: classes.step,
                                }}
                            >
                                <StepLabel color="#000">{step.label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    <Typography fontSize={14} component="p" lineHeight="initial" pt={2}>
                        If you don't receive an email in the next few minutes, check your
                        spam box. <br />
                        Not seeing the email?{' '}
                        <Typography
                            color="primary"
                            fontWeight={700}
                            component="span"
                            onClick={toggleModal}
                            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            Retry logging in
                        </Typography>
                    </Typography>
                </>
            }
        />
    )
};

export default MagicLinkModal;